import { render, staticRenderFns } from "./BpFilterButton.vue?vue&type=template&id=56dfa6fe&scoped=true&"
import script from "./BpFilterButton.vue?vue&type=script&lang=js&"
export * from "./BpFilterButton.vue?vue&type=script&lang=js&"
import style0 from "./BpFilterButton.vue?vue&type=style&index=0&id=56dfa6fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dfa6fe",
  null
  
)

export default component.exports